import Immutable from 'immutable';

import {
  UPDATE_PROFILE_PAGE,
  UPDATE_PROFILE_PAGE_HEADER_FLOAT,
  UPDATE_PROFILE_PAGE_SCROLL_TO_NAV,
  UPDATE_PROFILE_PAGE_HEADER_COLOR_PREVIEW,
  UPDATE_PROFILE_PAGE_HEADER_COLOR_SAVING,
  UPDATE_PROFILE_PAGE_HEADER_COLOR_PICKER,
  UPDATE_PROFILE_PAGE_FULLNAME_PREVIEW,
  UPDATE_PROFILE_PAGE_FULLNAME_EDITING,
  UPDATE_PROFILE_PAGE_FULLNAME_SAVING,
  UPDATE_PROFILE_PAGE_FULLNAME_WIDTH,
  UPDATE_PROFILE_PAGE_SHARE_SHOW,
  UPDATE_PROFILE_PAGE_SHOW_ALL_BADGES,
  UPDATE_PROFILE_PAGE_SHOW_ALL_FANS,
  UPDATE_PROFILE_PAGE_SET_PAGE_DIRTY,
  UPDATE_PROFILE_PAGE_SET_WARNING_CALLBACK,
} from './actions';

const INITIAL_STATE = Immutable.fromJS({
  byProfileName: {},
});

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export const ProfilePage = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_PROFILE_PAGE: {
      const { profile } = action;

      return state.setIn(
        ['byProfileName', profile.profileName],
        Immutable.fromJS(profile)
      );
    }
    case UPDATE_PROFILE_PAGE_HEADER_FLOAT: {
      const { profileName, headerFloat } = action;

      return state.setIn(
        ['byProfileName', profileName, 'headerFloat'],
        headerFloat
      );
    }
    case UPDATE_PROFILE_PAGE_SCROLL_TO_NAV: {
      const { profileName, scrollToNav } = action;

      return state.setIn(
        ['byProfileName', profileName, 'scrollToNav'],
        scrollToNav
      );
    }
    case UPDATE_PROFILE_PAGE_HEADER_COLOR_PREVIEW: {
      const { profileName, color } = action;

      return state.setIn(['byProfileName', profileName, 'headerColor'], color);
    }
    case UPDATE_PROFILE_PAGE_HEADER_COLOR_SAVING: {
      const { profileName, saving } = action;

      return state.setIn(
        ['byProfileName', profileName, 'headerColorSaving'],
        saving
      );
    }
    case UPDATE_PROFILE_PAGE_HEADER_COLOR_PICKER: {
      const { profileName, picker } = action;

      return state.setIn(
        ['byProfileName', profileName, 'headerColorPicker'],
        picker
      );
    }
    case UPDATE_PROFILE_PAGE_FULLNAME_PREVIEW: {
      const { profileName, fullName } = action;

      return state.setIn(['byProfileName', profileName, 'fullName'], fullName);
    }
    case UPDATE_PROFILE_PAGE_FULLNAME_EDITING: {
      const { profileName, editing } = action;

      return state.setIn(
        ['byProfileName', profileName, 'fullNameEditing'],
        editing
      );
    }
    case UPDATE_PROFILE_PAGE_FULLNAME_SAVING: {
      const { profileName, saving } = action;

      return state.setIn(
        ['byProfileName', profileName, 'fullNameSaving'],
        saving
      );
    }
    case UPDATE_PROFILE_PAGE_FULLNAME_WIDTH: {
      const { profileName, width } = action;

      return state.setIn(
        ['byProfileName', profileName, 'fullNameWidth'],
        width
      );
    }
    case UPDATE_PROFILE_PAGE_SHARE_SHOW: {
      const { profileName, show } = action;

      return state.setIn(['byProfileName', profileName, 'shareShow'], show);
    }
    case UPDATE_PROFILE_PAGE_SHOW_ALL_BADGES: {
      const { profileName, show } = action;

      return state.setIn(['byProfileName', profileName, 'showAllBadges'], show);
    }
    case UPDATE_PROFILE_PAGE_SHOW_ALL_FANS: {
      const { profileName, show } = action;

      return state.setIn(['byProfileName', profileName, 'showAllFans'], show);
    }
    case UPDATE_PROFILE_PAGE_SET_PAGE_DIRTY: {
      const { profileName, dirty } = action;

      return state.setIn(['byProfileName', profileName, 'pageDirty'], dirty);
    }
    case UPDATE_PROFILE_PAGE_SET_WARNING_CALLBACK: {
      const { callback } = action;

      return state.set('warningCallback', callback);
    }
    default: {
      return state;
    }
  }
};
